import AdClientService from '@/bundles/Ad/services/AdClientService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import AdClientToMapper from '@/bundles/Ad/mappers/AdClientToMapper';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function adClientServiceFactory () {
  return new AdClientService({
    transport: http,
    errorMapper: new ErrorMapper(),
    recordMapper: new AdClientToMapper(),
  });
}

export const adClientService = adClientServiceFactory();
